import { darken, lighten, rgba } from 'polished';
import styled from 'styled-components';

const BoxHeader = ({ icon, color, title, actions }) => {
  return (
    <StyledBoxHeader>
      {icon && (
        <IconWrapper>
          <BoxHeaderIcon color={color}>{icon}</BoxHeaderIcon>
        </IconWrapper>
      )}
      <TitleWrapper>
        <h3>{title}</h3>
      </TitleWrapper>
      <ActionsWrapper>{actions}</ActionsWrapper>
    </StyledBoxHeader>
  );
};

export default BoxHeader;

const StyledBoxHeader = styled.div`
  background-color: white;
  display: flex;
  border-radius: 10px 10px 0px 0px;
`;

const IconWrapper = styled.div`
  margin: 0px 15px;
`;

const TitleWrapper = styled.div`
  flex: 1;
  padding: 10px 0px;
  font-size: 1em;
  h3 {
    padding: 0;
    margin: 0;
  }
`;

const ActionsWrapper = styled.div`
  display: flex;
  padding: 5px 15px;
  gap: 5px;
`;

const BoxHeaderIcon = styled.div`
  float: left;
  padding: 15px;
  margin-right: 15px;
  background: linear-gradient(60deg, ${(props) => lighten(0.15, props.color)}, ${(props) => props.color});
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.14), 0 7px 10px -5px ${(props) => rgba(darken(0.2, props.color), 0.4)};
  position: relative;
  top: -15px;
  border-radius: 3px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
`;
